export default "__VITE_ASSET__DF1n295B__"